import { useRef } from 'react'
import { HiOutlineChevronRight } from 'react-icons/hi'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

export type GalleryImage = {
  id: string
  src: string
  alt?: string
  caption?: string
}

type ProjectGalleryRebrandProps = {
  images: GalleryImage[]
}

const CAROUSEL_SETTINGS = {
  arrows: false,
  dots: false,
  infinite: true,
  speed: 400,
  variableWidth: true,
  slidesToShow: 1,
  swipe: true,
  swipeToSlide: true,
  autoplay: true,
  autoplaySpeed: 4000,
  pauseOnHover: true,
  pauseOnFocus: true
}

export const ProjectGalleryRebrand = ({
  images
}: ProjectGalleryRebrandProps) => {
  const sliderRef = useRef<Slider>(null)

  if (!images.length) return null

  return (
    <div className='w-full'>
      <Slider ref={sliderRef} {...CAROUSEL_SETTINGS}>
        {images.map(image => (
          <div key={image.id} className='pr-5'>
            <div className='flex flex-col gap-2'>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={image.src}
                alt={image.alt || ''}
                className='h-[300px] md:h-[485px] w-auto object-cover'
              />
              {image.caption && (
                <p className='font-body-rebrand text-[12px] leading-[1.6] text-forestDeep m-0 max-w-[573px]'>
                  {image.caption}
                </p>
              )}
            </div>
          </div>
        ))}
      </Slider>

      <div className='flex justify-end items-center gap-4 mt-4'>
        <button
          type='button'
          aria-label='Previous image'
          onClick={() => sliderRef.current?.slickPrev()}
          className='w-12 h-12 rounded-full bg-limeBright hover:bg-limeBrightHover flex items-center justify-center transition-colors'
        >
          <HiOutlineChevronRight className='w-6 h-6 text-forestDeep rotate-180' />
        </button>
        <button
          type='button'
          aria-label='Next image'
          onClick={() => sliderRef.current?.slickNext()}
          className='w-12 h-12 rounded-full bg-limeBright hover:bg-limeBrightHover flex items-center justify-center transition-colors'
        >
          <HiOutlineChevronRight className='w-6 h-6 text-forestDeep' />
        </button>
      </div>
    </div>
  )
}
